interface CsvContentOptions {
    readonly cellDelimiter: string;
    readonly rowDelimiter: string;
}

const DefaultCsvContentOptions: CsvContentOptions = {
    cellDelimiter: ',',
    rowDelimiter: '\n',
};

const UNIVERSAL_BOM = '\uFEFF';

function createCsvBlob(csvContent: string): Blob {
    // The BOM makes Excel open UTF-8 CSVs with the correct encoding.
    return new Blob([UNIVERSAL_BOM + csvContent], {type: 'text/csv;charset=utf-8;'});
}

export function createCsvContent(csvData: any[][], options: CsvContentOptions = DefaultCsvContentOptions): string {
    return csvData.map((rowData) => rowData.join(options.cellDelimiter)).join(options.rowDelimiter);
}

export function downloadCsvFile(csvContent, fileName: string): void {
    const blob = createCsvBlob(csvContent);

    // IE / legacy Edge.
    const legacyNavigator = navigator as any;
    if (legacyNavigator.msSaveOrOpenBlob) {
        legacyNavigator.msSaveOrOpenBlob(blob, fileName);
        return;
    }

    // A blob: URL is downloadable on iOS WebKit (Safari/Chrome/etc.),
    // unlike a data: URI, which iOS silently refuses to download.
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = fileName;
    link.rel = 'noopener';
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();
    link.remove();

    // Give the browser a tick to start the download before releasing the URL.
    setTimeout(() => URL.revokeObjectURL(url), 400);
}
